import React, { useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Toast from './components/Toast';
import ViewerPage from './pages/ViewerPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';

export default function App() {
  const [stats, setStats]     = useState(null);
  const [toast, setToast]     = useState('');

  const showToast = useCallback((msg) => setToast(msg), []);
  const clearToast = useCallback(() => setToast(''), []);

  return (
    <BrowserRouter>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navbar stats={stats} />

        <main style={{ flex: 1 }}>
          <Routes>
            <Route
              path="/"
              element={
                <ViewerPage
                  onStats={setStats}
                  onToast={showToast}
                />
              }
            />
            <Route path="/about"   element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={
              <div style={{ textAlign: 'center', padding: '80px 40px' }}>
                <div style={{ fontSize: 48 }}>🔍</div>
                <div style={{ fontFamily: 'var(--sans)', fontSize: 28, fontWeight: 800, marginTop: 16 }}>404 — Page not found</div>
                <a href="/" style={{ color: 'var(--accent)', display: 'block', marginTop: 16 }}>← Back to Viewer</a>
              </div>
            } />
          </Routes>
        </main>

        <Footer />
        <Toast message={toast} onDone={clearToast} />
      </div>
    </BrowserRouter>
  );
}
